import React from 'react';
import { Row, Col, Empty, Spin, Typography } from 'antd';
import { EvolucionCard } from './EvolucionCard';

const { Text } = Typography;

export const EvolucionesList = ({ 
  evoluciones = [], 
  loading = false, 
  onDeleteEvolucion,
  deletingId = null 
}) => {
  if (loading) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '40px 20px',
        minHeight: '200px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Spin size="large" />
        <Text type="secondary" style={{ marginTop: '16px' }}>
          Cargando evoluciones...
        </Text>
      </div>
    );
  }

  if (!evoluciones || evoluciones.length === 0) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <Text type="secondary">
            Este Pokémon no tiene requerimientos de evolución configurados
          </Text>
        }
        style={{ 
          padding: '40px 20px',
          minHeight: '200px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      />
    );
  }

  return (
    <Row gutter={[32, 32]}>
      {evoluciones.map((evolucion, index) => (
        <Col xs={24} sm={24} lg={12} xl={12} key={evolucion.value}>
          <EvolucionCard
            evolucion={evolucion}
            onDelete={onDeleteEvolucion}
            isDeleting={deletingId === evolucion.value}
            key={index + 1}
          />
        </Col>
      ))}
    </Row>
  );
};
